import { forwardRef } from 'react';
import { Field, FieldProps, FieldValidator } from 'formik';

import { ComponentDataProps } from '../../types';
import { getIsInvalid } from '../common';
import { KeyboardTimePicker, KeyboardTimePickerProps } from '../KeyboardTimePicker';

export type FormKeyboardTimePickerProps = ComponentDataProps & {
  fieldProps: {
    name: string;
    validate?: FieldValidator;
  };
  timePickerProps?: Omit<KeyboardTimePickerProps, 'onChange' | 'value'>;
};

export const FormKeyboardTimePicker = forwardRef<HTMLInputElement, FormKeyboardTimePickerProps>(
  (
    {
      fieldProps,
      timePickerProps,
      'data-test': dataTest,
      'data-node-id': dataNodeID,
      'data-node-render-path': dataRenderPath,
    },
    ref,
  ) => {
    return (
      <Field name={fieldProps.name} validate={fieldProps.validate}>
        {({ field, meta, form }: FieldProps) => {
          const isInvalid = getIsInvalid({ meta, form });

          return (
            <KeyboardTimePicker
              ref={ref}
              {...timePickerProps}
              value={field.value}
              onChange={Time => form.setFieldValue(fieldProps.name, Time)}
              error={isInvalid}
              data-test={dataTest}
              data-node-id={dataNodeID}
              data-node-render-path={dataRenderPath}
            />
          );
        }}
      </Field>
    );
  },
);
